/* eslint-disable react/jsx-key */
import React, { useContext, useMemo, useState } from 'react'
import { strCol } from '@integec/grid-tools/lib/cols'

import {
  getApiTargetInfo,
  getClientInfo,
  getUnitNameMap,
  getUtilityNameMap,
} from 'core'
import {
  modifierCol,
  modifiedDateCol,
  utilityHeader,
  unitIdHeader,
} from 'core/HeaderColTypeProps'
import { connect } from 'react-redux'
import { getAuthorization, getNEUSers, getCredentials } from 'api/pgads.js'

import CommonScreen from '../CommonScreen'
import { Button, Icon, Upload, message } from 'antd'
import { isErrorContains } from 'core/component/JcTmpErrorDialog'
import { NE_NEW_ENGLAND } from 'client'
import { JcTmpErrorContext, SpinContext } from 'context'

const headers = [
  strCol({
    ident: 'userName',
    display: 'Username',
    width: 350,
    isKey: true,
    sortOrder: 'asc',
  }),
  strCol({
    ident: 'firstName',
    display: 'First Name',
    width: 200,
    sortOrder: 'asc',
  }),
  strCol({
    ident: 'lastName',
    display: 'Last Name',
    width: 200,
    sortOrder: 'asc',
  }),

  utilityHeader,

  unitIdHeader,

  strCol({
    ident: 'accessType',
    display: 'Access Type',
    isKey: true,
    width: 150,
    sortOrder: 'asc',
  }),

  modifierCol,
  modifiedDateCol,
]

const title = 'ISO-NE Users'

const NEUsers = ({ utilityNameMap, unitNameMap, apiTargetInfo, CLIENT }) => {
  const [insertEvent, setInsertEvent] = useState(false)
  const { setTmpError } = useContext(JcTmpErrorContext)
  const { setSpinning } = useContext(SpinContext)

  const headerWithFormatter = useMemo(
    _ =>
      headers.map(header =>
        header.ident === 'utility'
          ? {
              ...header,
              // ...toSelectionColProps(utilityNameMap),
              dataFormatter: ({ value }) =>
                `${value}` + ' - ' + `${utilityNameMap[value] || value}`,
              sortIndexGetter: ({ rowData }) =>
                utilityNameMap[rowData.utility] || rowData.utility,
            }
          : header.ident === 'unitId'
          ? {
              ...header,
              // choices: [],
              dataFormatter: ({ value, rowData }) =>
                `${rowData.unit}` + ' - ' + (unitNameMap[value] || value),
              sortIndexGetter: ({ rowData }) =>
                unitNameMap[rowData.unitId] || rowData.unitId,
            }
          : header
      ),
    [unitNameMap, utilityNameMap]
  )

  const fileProps = {
    name: 'file',
    action: `${apiTargetInfo.baseUrl}/ne-import/user`,
    method: 'POST',
    headers: getAuthorization(apiTargetInfo),
    ...getCredentials(apiTargetInfo),
  }
  const extraCriteriaAfterButton = ({ onRetrieve }) => {
    if (CLIENT === NE_NEW_ENGLAND)
      return (
        <Upload
          {...fileProps}
          beforeUpload={_ => setSpinning(true)}
          onChange={data => {
            if (data.file.status === 'error') {
              setSpinning(false)
            }

            if (data.file.status === 'done') {
              setSpinning(false)

              // setImportResponse(data.file.response)
              const errors = data.file.response
              if (errors.length > 0) setTmpError(errors)
              if (!isErrorContains(errors)) {
                message.success('File imported successfully')
                onRetrieve()
              }
            }
          }}
          multiple={false}
          showUploadList={false}
        >
          <Button style={{ marginLeft: '5px' }}>
            <Icon type="upload" /> Import
          </Button>
        </Upload>
      )
    else return <div />
  }

  return (
    <CommonScreen
      title={title}
      header={headerWithFormatter}
      saveTask={getNEUSers}
      retrieveTask={getNEUSers}
      deleteTask={getNEUSers}
      autoRetrieve
      sortOptions={headers}
      widthOffset={50}
      insertComp={insertEvent}
      insertCompHeight={150}
      onInsertEvent={_ => setInsertEvent(false)}
      withDelete={false}
      withoutModify
      allowInsert={false}
      extraCriteriaAfterButton={extraCriteriaAfterButton}
    />
  )
}

const mapStateToProps = state => ({
  apiTargetInfo: getApiTargetInfo(state),
  utilityNameMap: getUtilityNameMap(state),
  unitNameMap: getUnitNameMap(state),
  CLIENT: getClientInfo(state),
})

export default connect(mapStateToProps)(NEUsers)
